import React, { Component } from 'react';  import { withRouter, Redirect } from 'react-router-dom';
import { Product } from './Products';
import { Route } from 'react-router';
import Login from './Login';

export class Registered extends Component {
    displayName = Registered.name

    constructor(props) {
        super(props);
        this.state = {
            toProducts: false,
            toLogIn: false
        };

    }













































    GoBackToProducts() {
        this.setState({ toProducts: true });
    }

    GoBackToLogin() {
        this.setState({ toLogIn: true });
    }



    render() {

        if (this.state.toProducts) {
            return <Route path='/' component={Product} />
        }

        if (this.state.toLogIn) {
            return <Route path='/' component={Login} />
        }

        else {
            return (
                <div className="outer-container customer_background" >
                    <div className="header" style={{ position: 'fixed', zIndex : '500'}}>
                        <div className="grid_container_header" style={{ display: 'inline-grid', gridTemplateColumns: '30% 40% 30%', display: 'grid -ms-grid', msGridColumns: '30% 40% 30%', columnCount: '3' }}>
                            <div className="grid_header">
                                <div className="icon_home" style={{ width: '100%', height: '50%', 'margin-top': '30px', 'margin-left': '10%', float: 'left', 'background-repeat': 'no-repeat' }}></div>
                            </div>
                            <div className="grid_header" style={{ 'text-align': 'left' }}>
                                <div className="header_container" style={{ width: '100%' }}>
                                    <div>
                                        <div style={{ display: 'inline' }}>
                                            <a className="header_text" href='http://www.lithothech.co.za' id="A1">Back to Lithothec</a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="grid_header">
                                <div className="header_container" style={{ width: '100%' }}>
                                    <div>
                                        <div style={{ display: 'inline' }}>
                                            <a className="header_text" onClick={() => this.GoBackToLogin()} id="A1">LOG IN</a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="inner-container">
                        <div className="centered-content  twfont customer_background_foreground" style={{ width: '90%', 'box-shadow': '2px 2px 8px #888888', border: 'none', 'border-radius': '2%', padding: '2%' }}>
                            <hr /> <label style={{ fontSize: 'x-large', fontFamily: 'TW Cen MT' }}>Thank you for registering.  The Ecommerce administrator will review your request and notify you once the registration has been approved.  <hr /><i className="material-icons" style={{ position: 'absolute', paddingLeft: '10px' }}>thumb_up</i> </label>
                            <br />
                            <br />
                        </div >
                    </div >
                </div >
            );
        }
    }
}

